export default __webpack_public_path__ + "static/media/reason_progress.66b67963.svg";